import {getUrlParameter} from '../../../utils/js/getUrlParameter';

const htmlDiscountTpl = (wordings, device) => {
  const value_wording = wordings[`discount_value_${GLOBAL_SCRIPTS.MARKET_CODE.toLowerCase() === 'fr' ? 'FR' : 'BNG'}`];

  return `
<span class="cartouche-discountFlag${device === 'desktop' ? ' u-Visible-desktop' : ''}">
  <span class="cartouche-discountFlag--value">${typeof value_wording === 'string' ? value_wording.replace('%', '<span class="cartouche-discountFlag--percent">%</span>') : ''}</span>
  <span class="cartouche-discountFlag--text">${wordings.discount_text}</span>
</span>`;
};

const getUriParams = function () {
  const storedSearchParamsCookie = cookieManagement.getCookie('storedSearchParams');
  const storedSearchParams = storedSearchParamsCookie !== null ? JSON.parse(storedSearchParamsCookie) : {};
  const isFlexPeriodStore = typeof storedSearchParams.flexPeriod !== 'undefined' && storedSearchParams.flexPeriod;
  const isFlexPeriodUrl = typeof getUrlParameter('option[flexholiday]') !== 'undefined';

  return isFlexPeriodStore || isFlexPeriodUrl ? '&dateuser=0&option[date_range]=1&option[flexholiday]=1' : '';
};

export { htmlDiscountTpl, getUriParams };